import React from 'react'
import {BaseButton, Stack, Text} from '../../../vanilla'
import {Link} from '../../link'

export const LoginButtons = () => {
  return (
    <Stack direction="row" spacing="8px" borderRadius="medium" padding="12px">
      <BaseButton
        variant="outlinePrimary"
        flexBasis="half"
        size="sm"
        as={Link}
        to="/account/register"
        style={{backgroundColor: 'white'}}
      >
        <Text
          variant="unstyled"
          data-test-selector="register"
          fontSize="inherit"
          fontWeight="inherit"
          lineHeight="inherit"
          color="inherit"
        >
          Register
        </Text>
      </BaseButton>
      <BaseButton flexBasis="half" size="sm" as={Link} to="/login">
        <Text
          variant="unstyled"
          data-test-selector="mobile-login"
          fontSize="inherit"
          fontWeight="inherit"
          lineHeight="inherit"
          color="inherit"
        >
          Sign In
        </Text>
      </BaseButton>
    </Stack>
  )
}
